import * as React from "react"

/**
 * Toggle switch.
 * Props:
 *  checked          boolean
 *  onChange         (newChecked: boolean) => void
 *  onCheckedChange  (newChecked: boolean) => void  – alias for onChange
 *                   (shadcn/Radix Switch convention used by most callers)
 *  disabled  boolean
 *  loading   boolean  – shows spinner instead of knob
 */
export function Switch({
  checked = false,
  onChange,
  onCheckedChange,
  disabled = false,
  loading = false,
}) {
  const handleChange = onChange ?? onCheckedChange;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled || loading}
      onClick={() => !disabled && !loading && handleChange?.(!checked)}
      className={`
        relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full
        border-2 border-transparent transition-colors duration-200
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-500
        disabled:cursor-not-allowed disabled:opacity-50
        ${checked ? 'bg-emerald-500' : 'bg-zinc-600'}
      `}
    >
      <span
        className={`
          pointer-events-none inline-flex h-4 w-4 items-center justify-center
          rounded-full bg-white shadow-sm ring-0 transition-transform duration-200
          ${checked ? 'translate-x-4' : 'translate-x-0'}
        `}
      >
        {loading && (
          <span className="h-2.5 w-2.5 rounded-full border-2 border-zinc-400 border-t-transparent animate-spin" />
        )}
      </span>
    </button>
  )
}
